import { useState } from 'react';

interface HeaderProps {
  isScrolled: boolean;
}

export default function Header({ isScrolled }: HeaderProps) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
        }`}
      >
        <div className="w-full px-6 lg:px-12">
          <div className="flex items-center justify-between h-20">
            <div className="flex items-center gap-4 cursor-pointer" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
              <img
                src="https://static.readdy.ai/image/5d630725553570e05f3758f7a11d9e41/353f16a16795e047dc333f0dcc625b61.png"
                alt="株式会社南場組"
                className="h-20 w-auto"
              />
              <div className={`text-2xl font-bold transition-colors ${
                isScrolled ? 'text-gray-800' : 'text-white'
              }`}>
                株式会社 南 場 組
              </div>
            </div>

            <nav className="hidden lg:flex items-center space-x-8">
              <button
                onClick={() => scrollToSection('top')}
                className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  isScrolled ? 'text-gray-800 hover:text-teal-600' : 'text-white hover:text-teal-300'
                }`}
              >
                トップ
              </button>
              <button
                onClick={() => scrollToSection('about')}
                className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  isScrolled ? 'text-gray-800 hover:text-teal-600' : 'text-white hover:text-teal-300'
                }`}
              >
                会社概要
              </button>
              <button
                onClick={() => scrollToSection('works')}
                className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  isScrolled ? 'text-gray-800 hover:text-teal-600' : 'text-white hover:text-teal-300'
                }`}
              >
                施工実績
              </button>
              <button
                onClick={() => scrollToSection('contact')}
                className={`px-6 py-2.5 bg-teal-600 text-white text-sm font-medium rounded-md hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer`}
              >
                お問い合わせ
              </button>
            </nav>

            <button
              className="lg:hidden p-2 cursor-pointer"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
              <div className="w-6 h-5 flex flex-col justify-between">
                <span className={`block h-0.5 w-full transition-all ${isScrolled ? 'bg-gray-800' : 'bg-white'}`}></span>
                <span className={`block h-0.5 w-full transition-all ${isScrolled ? 'bg-gray-800' : 'bg-white'}`}></span>
                <span className={`block h-0.5 w-full transition-all ${isScrolled ? 'bg-gray-800' : 'bg-white'}`}></span>
              </div>
            </button>
          </div>
        </div>
      </header>

      {isMobileMenuOpen && (
        <div className="fixed inset-0 z-40 lg:hidden">
          <div className="absolute inset-0 bg-black/50" onClick={() => setIsMobileMenuOpen(false)}></div>
          <div className="absolute top-20 right-0 w-64 bg-white shadow-xl">
            <nav className="flex flex-col p-6 space-y-4">
              <button
                onClick={() => scrollToSection('top')}
                className="text-left text-gray-800 hover:text-teal-600 font-medium cursor-pointer"
              >
                トップ
              </button>
              <button
                onClick={() => scrollToSection('about')}
                className="text-left text-gray-800 hover:text-teal-600 font-medium cursor-pointer"
              >
                会社概要
              </button>
              <button
                onClick={() => scrollToSection('works')}
                className="text-left text-gray-800 hover:text-teal-600 font-medium cursor-pointer"
              >
                施工実績
              </button>
              <button
                onClick={() => scrollToSection('contact')}
                className="text-left text-gray-800 hover:text-teal-600 font-medium cursor-pointer"
              >
                お問い合わせ
              </button>
            </nav>
          </div>
        </div>
      )}
    </>
  );
}
